import { LocationData } from '../commons';
import { BottomSheetData } from './bottom-sheet-data';

export interface SelectAddressData extends BottomSheetData {
  place: LocationData;
}
